"use strict";
// Scheduled Analytics Report (DEV-2377, §6) — the wire shape shared by the API and
// the frontend. It's a trimmed v2 `report_requests` row (drops the legacy PPC-only
// columns) using the row's own field names: label / period / scheduled_for /
// generated_at. Dates are typed `Date` per the response-DTO convention (they
// serialize to ISO strings on the wire).
Object.defineProperty(exports, "__esModule", { value: true });
